import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const CustomBarChart = ({ data, barkey, xAxisField, name }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey={xAxisField} />
                <YAxis tickFormatter={(value) => Math.floor(value)} />
                <Tooltip />
                <Legend />
                <Bar dataKey={barkey} fill="#8884d8" name={name} />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default CustomBarChart;
